'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/es6.js
// module id = 349
// module chunks = 35783957827783 172322841747965